import React, {useEffect, useState} from 'react';
import {Box} from "@mui/material";
import CustomerEdgesTable from "../../../components/UI/table/customer-detales/eges/CustomerEdgesTable";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import OrderEdgeControllerOrganization from "../../../API/details/organization/OrderEdgeControllerOrganization";

const OrganizationEdges = ({itemId, handleModalAlert, orderId, model, composition}) => {
    const isReserve = !!itemId
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })

    const [isError, setIsError] = useState(false);

    const [data, setData] = useState([]);

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`settings+${itemId}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`settings+${itemId}`]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    useEffect(() => {
        getStartPageSize()
        const api = model ? OrderEdgeControllerOrganization.getForModel() :
            composition ? OrderEdgeControllerOrganization.getForComposition() :
            isReserve ? OrderEdgeControllerOrganization.getAll() :
                OrderEdgeControllerOrganization.getById(orderId)
        api.then(function (response) {
            const data = response?.data
            setData(data);
            setIsError(false)
        })
            .catch(function (error) {
                handleModalAlert(error)
            })

    }, [model, composition]);

    return (
        <Box>
            <CustomerEdgesTable
                data={data}
                isError={isError}
                setData={setData}
                enableEditing={true}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
                handleModalAlert={handleModalAlert}
                orderId={orderId}
                reserve={isReserve}
                organization={true}
                model={model}
                composition={composition}/>
        </Box>
    )
}
export default OrganizationEdges